// import external dependencies
import 'headroom.js';
import 'headroom.js/dist/jQuery.headroom';
import 'jquery-match-height';

import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/respimg/ls.respimg'

import Swiper from 'swiper/dist/js/swiper.js';
// set global swiper
window.Swiper = Swiper;

// import local dependencies
import Components from './util/components';
import ReadingList from './components/reading-list';
import ThemeChild from './components/theme-child';
import Navigation from './components/navigation';
import NewsletterPopup from './components/newsletter-popup';
import Vue from './components/vue';

const components = new Components([
    ReadingList,
    ThemeChild,
    Navigation,
    Vue,
    NewsletterPopup
]);

components.fire('init', $);
/** Load Events */
jQuery(document).ready(($) => {
    components.fire('ready', $);
});
jQuery(window).on('load', ($) => components.fire('loaded', $));
